import { Typography } from '@packages/ui/shared';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

type StepOneContentProps = {
    currentStep: number;
    displayQrCodeScanner: boolean;
};

const StepOneContent: React.FC<StepOneContentProps> = ({ currentStep, displayQrCodeScanner }) => {
    const [displayThisStep, setDisplayThisStep] = useState(false);

    useEffect(() => {
        setDisplayThisStep(currentStep === 1 && !displayQrCodeScanner);
    }, [currentStep, displayQrCodeScanner]);

    if (!displayThisStep) return null;

    return (
        <Modal.Body>
            <div className="mb-2">
                <Typography variant="label">Use Mobile App for Easier Scanning</Typography>
            </div>
            <div className="mb-2">
                <Typography variant="default">
                    You can complete this action from the web app, but we recommend using the mobile app to scan the
                    battery pack labels more easily with your device.
                </Typography>
            </div>
        </Modal.Body>
    );
};

export default StepOneContent;
